import {
  inject,
  Signal,
  OnInit,
  OnDestroy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { ChartType } from 'src/app/operations-dashboard/types/chart-type';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KpiChart } from '../download-charts-pdf.types';

@Component({
    selector: 'app-download-charts-pdf-dialog',
    styleUrls: ['./download-charts-pdf-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
    <section [id]="containerId" class="simple-container">
      <div>
        <p>Summary Dashboard Report</p>
        <p>{{ today | date: 'MM/dd/yy' }}</p>
      </div>

      @for (displayGroup of displayCharts; track $index) {
        <div class="simple-flex">
          @for (displayChart of displayGroup; track $index) {
            @if (displayChart(); as chart) {
              @switch (chart.data.type) {
                @case (ChartType.GAUGE) {
                  <app-gauge-value
                    class="stat__item"
                    [ngClass]="chart.ngClass"
                    [data]="chart.data"
                  ></app-gauge-value>
                }
                @case (ChartType.SINGLE) {
                  <app-single-value
                    class="stat__item"
                    [ngClass]="chart.ngClass"
                    [data]="chart.data"
                  ></app-single-value>
                }
                @case (ChartType.LINE) {
                  <app-line-values
                    class="stat__item"
                    [ngClass]="chart.ngClass"
                    [data]="chart.data"
                    [loading]="chart.loading"
                  ></app-line-values>
                }
                @case (ChartType.BARSH) {
                  <app-horizontal-bars
                    class="stat__item"
                    [ngClass]="chart.ngClass"
                    [data]="chart.data"
                    [loading]="chart.loading"
                  ></app-horizontal-bars>
                }
                @case (ChartType.BARSV) {
                  <app-vertical-bars
                    class="stat__item"
                    [ngClass]="chart.ngClass"
                    [data]="chart.data"
                    [loading]="chart.loading"
                  ></app-vertical-bars>
                }
              }
            }
          }
        </div>
      }
    </section>
  `,
    standalone: false
})
export class DownloadChartsPdfDialogComponent implements OnInit, OnDestroy {
  private readonly matDialogData = inject<{
    displayCharts: Signal<KpiChart>[][];
    containerId: string;
  }>(MAT_DIALOG_DATA);

  readonly containerId = this.matDialogData.containerId;

  readonly displayCharts: Signal<KpiChart>[][] =
    this.matDialogData.displayCharts;

  readonly today: Date = new Date();

  readonly ChartType = ChartType;

  ngOnInit(): void {
    document.documentElement.style.position = 'initial';
  }

  ngOnDestroy(): void {
    document.documentElement.style.position = null!;
  }
}
